import React, { useState, useEffect } from "react";
import { getBulkSaleTaxReport } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import SideBar from "../../sidebar/sideBar";
import Header from "../../header/header";
import {
  getAllPartySearch,
  getAllItemsSearch,
} from "../../../api/endpoints/search";
import { getSingleParty } from "../../../api/endpoints/party";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSiteRefrence, updateRefrence } from "../../../api/endpoints/refrences";

import { Select } from "antd";

const { Option } = Select;

const SaleTaxInv = () => {
  const { user, access_token } = useSelector(authSelector);
  const [itemsQueue, setItemsQueue] = useState([]);
  const [state, setState] = useState({
    parties: [],
    items: [],
    startingDate: "",
    endingDate: "",
    partyId: "",
    partyName: "",
    itemCode: "",
    itemName: "",
    SVNO: "",
    customerNTN: "",
    customerSaleTaxNo: "",
    invNo: "",
    STR: "",
    gstChk: "",
    NTN: "",
    PO: "",
    invDate: "",
  });

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  const clearState = () => {
    setItemsQueue([]);
  };

  const clearFields = () => {
    setState({
      parties: state.parties,
      items: state.items,
      partyId: "",
      partyName: "",
      itemCode: "",
      itemName: "",
      endingDate: "",
      startingDate: "",
      SVNO: "",
    });
  };

  const editHandler = async (e) => {
    if (!state.startingDate && !state.endingDate)
      return message.error("Please type date !");
    if (!state.itemCode) return message.error("Please type Item !");
    if (!state.partyId) return message.error("Please type Party !");
    let data = {
      startingDate: state.startingDate,
      endingDate: state.endingDate,
      itemCode: state.itemCode,
      partyId: state.partyId,
      siteId: Number(user.siteId),
    };

    const results = await getBulkSaleTaxReport(data, access_token);
    if (results.data.length === 0) {
      message.error("No Record Found in this date");
    }
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            enteredOn: curr.enteredOn,
            // shift: curr.shift,
            itemCode: Number(curr.itemCode),
            quantity: Number(curr.quantity),
            saleRate: Number(curr.saleRate),
            amount: Number(curr.amount),
            lorryNo: curr.lorryNo,
            remrks: curr.remrks,
            itemName: curr.item.itemName,
            partyName: curr.party.partyName,
            siteId: curr.siteId,
            SVNO: curr.SVNO,
          },
        ];
      }, []);
      setItemsQueue(payload);
      generatePDF(payload);
      let invUpdateNo = {
        invoiceNo:  state.invNo + 1,
        siteId: Number(user.siteId)
      }
      const invUpdate = await updateRefrence(invUpdateNo, access_token);
      const result = await getSiteRefrence(access_token);
       setState({
      ...state,
      invNo: result.data.invoiceNo
    });

    } else {
      message.error(results.message);
    }
  };
  console.log(state, "statee");

  const getPartyIdUpdated = async () => {
    if (!state.partyId) return; // prevent empty call

    const _singleParty = await getSingleParty(state.partyId, access_token);

    if (_singleParty) {
      setState((prev) => ({
        ...prev,
        customerSaleTaxNo: _singleParty.data.saleTaxRNo,
        customerNTN: _singleParty.data.NTNNO,
      }));
    }
  };

  useEffect(() => {
    getPartyIdUpdated();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.partyId]);

  const getAllData = async () => {
    const result = await getSiteRefrence(access_token);
    const _items = await getAllItemsSearch(access_token);
    const _parties = await getAllPartySearch(access_token);
    setState({
      ...state,
      items: _items,
      parties: _parties,
      STR: result.data.saleTaxNo,
      NTN: result.data.NTNNO,
      invNo: result.data.invoiceNo

    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

// Helper function: convert number to words
const numberToWords = (amount) => {
  const th = ["", "Thousand", "Million", "Billion", "Trillion"];
  const dg = ["Zero","One","Two","Three","Four","Five","Six","Seven","Eight","Nine"];
  const tn = ["Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
  const tw = ["Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
  amount = amount.toString().replace(/[\, ]/g,'');
  if(isNaN(amount)) return "Not a number";
  let x=amount.indexOf(".");
  let n=x===-1?amount.length:x;
  let str=""; let sk=0;
  for(let i=0;i<n;i++){
    if((n-i)%3===2){
      if(amount[i]==="1"){
        str+=tn[Number(amount[i+1])]+" "; i++; sk=1;
      } else if(amount[i]!=="0"){ str+=tw[Number(amount[i])-2]+" "; sk=1;}
    } else if(amount[i]!=="0"){ str+=dg[Number(amount[i])]+" "; if((n-i)%3===0)str+="Hundred "; sk=1;}
    if((n-i)%3===1){ if(sk)str+=th[(n-i-1)/3]+" "; sk=0;}
  }
  if(x!==-1){ let y=amount.length; str+="Point "; for(let i=x+1;i<y;i++) str+=dg[Number(amount[i])]+" "; }
  return str.trim() + " Only";
};

const generatePDF = (data) => {
  if (!data || data.length===0) { message.error("No data to generate PDF"); return; }

  const doc = new jsPDF("p","mm","a4");

  // ===== HEADER =====
  doc.setFontSize(14); doc.setFont(undefined,"bold");
  doc.text("SALE TAX INVOICE",105,10,{align:"center"});

  doc.setFontSize(9); doc.setFont(undefined,"bold");
  // Left labels
  const leftXLabel=14,leftXValue=55;
  doc.text("Customer:",leftXLabel,20);
  doc.text("Customer NTN:",leftXLabel,26);
  doc.text("Customer Sale Tax No:",leftXLabel,32);

  doc.setFont(undefined,"normal");
  doc.text(`${state.partyName}`,leftXValue,20);
  doc.text(`${state.customerNTN}`,leftXValue,26);
  doc.text(`${state.customerSaleTaxNo}`,leftXValue,32);

  // Right labels
  const rightXLabel=140,rightXValue=170;
  doc.setFont(undefined,"bold");
  doc.text("Invoice No:",rightXLabel,20);
  doc.text("Invoice Date:",rightXLabel,26);
  doc.text("Sale Tax No:",rightXLabel,32);
  doc.text("NTN:",rightXLabel,38);
  // doc.text("PO:",rightXLabel,44);

  doc.setFont(undefined,"normal");
  // doc.text(`4058`,rightXValue,20);
  doc.text(`${state.invNo}`,rightXValue,20);
  doc.text(`${state.invDate}`,rightXValue,26);
  doc.text(`${state.STR}`,rightXValue,32);
  doc.text(`${state.NTN}`,rightXValue,38);
  // doc.text(`${state.PO}`,rightXValue,44);

  // Center period
  // doc.setFont(undefined,"bold");
  // doc.text(`Period: ${state.startingDate} to ${state.endingDate}`,105,50,{align:"center"});

  // ===== TABLE ROWS =====
  const tableRows = data.map((r,index)=>[
    index+1,r.enteredOn,r.itemCode,r.itemName,
    r.quantity.toLocaleString(),
    r.saleRate.toLocaleString(undefined,{minimumFractionDigits:2}),
    r.amount.toLocaleString(undefined,{minimumFractionDigits:2})
  ]);

  const totalQty = data.reduce((a,b)=>a+b.quantity,0);
  const subTotal = data.reduce((a,b)=>a+b.amount,0);
  tableRows.push(["","","","SUB TOTAL",totalQty.toLocaleString(),"",subTotal.toLocaleString(undefined,{minimumFractionDigits:2})]);

  let gstAmount = 0, grandTotal = subTotal;

  // ===== GST (18%) if checkbox is checked =====
  if (state.gstChk) {
    gstAmount = +(subTotal*0.18).toFixed(2);
    grandTotal = +(subTotal+gstAmount).toFixed(2);
    tableRows.push(["","","","General Sales Tax (18%)","","",gstAmount.toLocaleString(undefined,{minimumFractionDigits:2})]);
    tableRows.push(["","","","GRAND TOTAL","","",grandTotal.toLocaleString(undefined,{minimumFractionDigits:2})]);
  }

  // ===== AUTOTABLE =====
  autoTable(doc,{
    startY:55,
    head:[["S#","Date","Item Code","Item Name","Qty","Rate","Amount"]],
    body: tableRows,
    theme:"grid",
    styles:{fontSize:9,cellPadding:2,textColor:[0,0,0],lineColor:[0,0,0],lineWidth:0.4},
    headStyles:{fillColor:[220,220,220],textColor:[0,0,0],fontStyle:"bold",halign:"center"},
    columnStyles:{0:{halign:"center",cellWidth:10},1:{halign:"center",cellWidth:22},2:{halign:"center",cellWidth:25},3:{halign:"left",cellWidth:55},4:{halign:"right",cellWidth:20},5:{halign:"right",cellWidth:25},6:{halign:"right",cellWidth:30}},
    didParseCell:(hookData)=>{
      if(["SUB TOTAL","General Sales Tax (18%)","GRAND TOTAL"].includes(hookData.row.raw?.[3])){
        hookData.cell.styles.fontStyle="bold";
        hookData.cell.styles.fillColor=[245,245,245];
      }
    }
  });

  // ===== Amount in Words =====
  const wordsY = doc.lastAutoTable.finalY + 8;
  doc.setFont(undefined,"bold");
  doc.text(`Amount in Words: ${numberToWords(grandTotal)}`,14,wordsY);

  // ===== FOOTER =====
  doc.setFontSize(8); doc.setFont(undefined,"italic");
  doc.text("This is a system generated invoice",105,285,{align:"center"});

  // ===== OPEN PDF =====
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
};




  return (
    <>
      <div className="flex  bg-black main">
        <SideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <Header />
          <div className="flex justify-center mt-10">
            <div className="meterTableMain flex flex-col justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className="text-white ">Sale Tax (GST)</h1>
              </div>
              <div className="flex flex-col content-center items-center justify-items-center justify-evenly">
                <div className="mt-4">
                  <div className="flex items-center">
                    <label className="text-white" htmlFor="startDate">
                      Starting Date:
                    </label>
                    <input
                      type="date"
                      name="startingDate"
                      className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                      onChange={onChangeText}
                    />
                    <label className="text-white ml-5" htmlFor="endDate">
                      Ending Date:
                    </label>
                    <input
                      type="date"
                      name="endingDate"
                      className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                      onChange={onChangeText}
                    />
                  </div>

                  <div className="flex items-center">
                    <label className="text-white" htmlFor="startDate">
                      Invoice Date:
                    </label>
                    <input
                      type="date"
                      name="invDate"
                      className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                      onChange={onChangeText}
                    />
                  </div>
                </div>
                <div className="flex pb-3 items-center">
                  <Select
                    showSearch
                    className="mt-2 ml-3 h-8 p-1 w-36"
                    placeholder="Party Code"
                    optionFilterProp="children"
                    value={state.partyId || "Party Code"}
                    onChange={(e) => {
                      const lCode = state.parties.find(
                        (el) => el.partyId === e,
                      );
                      setState({
                        ...state,
                        partyId: e,
                        partyName: lCode.PartyName,
                      });
                    }}
                  >
                    {state.parties.map((el) => (
                      <Option value={el.partyId} key={el.partyId}>
                        {el.partyId}
                      </Option>
                    ))}
                  </Select>
                  <Select
                    showSearch
                    className="mt-2 ml-3 h-8 p-1 w-60"
                    placeholder="Party Name"
                    optionFilterProp="children"
                    value={state.partyName || "Party Name"}
                    onChange={(e) => {
                      const lCode = state.parties.find(
                        (el) => el.partyId === e,
                      );
                      setState({
                        ...state,
                        partyId: e,
                        partyName: lCode.PartyName,
                      });
                    }}
                  >
                    {state.parties.map((el) => (
                      <Option value={el.partyId} key={el.partyId}>
                        {`${el.partyId} - ${el.PartyName}`}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="flex pb-3 items-center">
                  <label className="flex items-center gap-2 ml-3 mb-3 text-white">
                    <input
                      type="checkbox"
                      name="gstChk"
                      checked={state.gstChk === true}
                      onChange={(e) =>
                        setState({
                          ...state,
                          gstChk: e.target.checked,
                        })
                      }
                      className="h-4 w-4  cursor-pointer"
                    />
                    Apply 18% General Sales Tax
                  </label>
                </div>
                <div className="flex pb-3 items-center">
                  <Select
                    showSearch
                    placeholder="Select item"
                    className="mt-2 ml-3 h-8 p-1 w-36"
                    optionFilterProp="children"
                    value={state.itemCode || "Item"}
                    onChange={(e) => {
                      const { itemName: productName } = state.items.find(
                        (el) => el.itemCode === e,
                      );
                      setState({
                        ...state,
                        itemCode: e,
                        itemName: productName,
                      });
                    }}
                  >
                    {state.items.map((el) => (
                      <Option value={el.itemCode}>{el.itemCode}</Option>
                    ))}
                  </Select>
                  <Select
                    showSearch
                    placeholder="Select Product Name"
                    optionFilterProp="children"
                    className="mt-2 ml-3 h-8 p-1 w-60"
                    value={state.itemName || "Prodct Name"}
                    onChange={(e) => {
                      const { itemName: productName } = state.items.find(
                        (el) => el.itemCode === e,
                      );
                      setState({
                        ...state,
                        itemCode: e,
                        itemName: productName,
                      });
                    }}
                  >
                    {state.items.map((el) => (
                      <Option
                        value={el.itemCode}
                      >{`${el.itemCode} - ${el.itemName}`}</Option>
                    ))}
                  </Select>

                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-2 ml-3 py-1 px-4 rounded"
                    onClick={editHandler}
                  >
                    View
                  </button>
                  <button
                    onClick={clearFields}
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-2 ml-3 py-1 px-4 rounded"
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SaleTaxInv;
